<template>
  <div class="zj-demo-player">
    <zj-layout-container>
      <zj-layout-header>
        <h1 style="margin: 0rem 6rem;">视频播放器</h1>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable" ref="container">

<!--
          <div>
            <video ref="video1"  width="640" height="400" muted controls></video>
          </div>
-->

          <div v-for="item in cameras" :key="item.cameraId"
            style="display:inline-block;border:1px solid #666;margin: 8px 8px;">
            <zj-camera-preview
              :cameraId="item.cameraId"
              :cameraName="item.cameraName"
              :streamType="item.streamType"
              :autoplay="item.autoplay"
              style="width:256px; height:128px;" />
          </div>
          
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
//import Wfs from '../../../../../player/wfs/wfs.js';
export default {
    name: 'ZjDemoPlayer',
    controller: 'UI',
    action: 'player',
    data () {
      return {
        cameras: [
          /* streamType 为码流类型： 0 - 主码流；1 - 子码流；2 - 第三码流。
          主码流较清晰，分辨率一般为 1280x720，子码流为标清，分辨率为 704x576。
          请根据网络情况选择主码流还是子码流。 */
          { streamType: 0, autoplay: true, cameraId: '5c54baf9918b460ab6698437686161c8', cameraName: '大河关码头报警柱' },
          { streamType: 0, autoplay: false, cameraId: 'ec4720b3fe9448c385ca764e56b42618', cameraName: '至圣码头报警柱' },
          { streamType: 1, autoplay: false, cameraId: '0fd3011c2fc44da89ef3cb4f724c5601', cameraName: '府衙码头报警柱' },
          { streamType: 1, autoplay: false, cameraId: 'bf589efde0f84c9680d711e2f92ac006', cameraName: '停车场2' },
          { streamType: 1, autoplay: false, cameraId: 'a7dd56fc988b48b583441da3a4bf77c7', cameraName: '玉女泉' },
          { streamType: 1, autoplay: false, cameraId: '92f20daf33b744409a1293e1c18d36e3', cameraName: '第一桥' },
          { streamType: 1, autoplay: false, cameraId: '62cdf4fdd0704596a9aa2a923df6286f', cameraName: '苗女照' },
          { streamType: 1, autoplay: false, cameraId: '4cf7d98400d84d848781160ffc7d27c6', cameraName: '何家大院' },
          { streamType: 1, autoplay: false, cameraId: '3a89b49fb1654230ae2adb25436bcf59', cameraName: '吉祥寺码头' },
          { streamType: 1, autoplay: false, cameraId: '86e9fbf55af44d07ac0a0168511f996f', cameraName: '仁寿宫' },
          { streamType: 1, autoplay: false, cameraId: 'ed5692b3427a49249d0e2b63bcf1bf24', cameraName: '城隍庙码头' },
          { streamType: 1, autoplay: false, cameraId: '073ab98a9f64491a82eb59a36e47a1d7', cameraName: '龙潭2' },
          { streamType: 1, autoplay: false, cameraId: 'f192bcfdb9904bdf94f1079fc1cc00df', cameraName: '水师营码头2' },
          { streamType: 1, autoplay: false, cameraId: 'c7fbfa8f939048aaad96c0032fd60545', cameraName: '天后宫码头' },
          { streamType: 1, autoplay: false, cameraId: 'faf550772b1f4cdab02278b7f7535689', cameraName: '珍珠潭' },
          { streamType: 1, autoplay: false, cameraId: '0bae4c305c98497095c8343a4d171965', cameraName: '居然南海' }
        ]
      };
    },

    /*
    mounted() {
      this.$nextTick(()=>{
        this.wfs = new Wfs({
          appConfig: this.config
        });    
        this.wfs.attachMedia(this.$refs.video1, {
          cameraId: 'ec4720b3fe9448c385ca764e56b42618',
          cameraName: '至圣码头报警柱',
          scaleMode: 1,
          streamType: 1,
          zipMethod: 2
        });
      });

    },
    destroyed() {
      if (this.wfs) {
        this.wfs.destroy();
        this.wfs = null;
      }
    }
    */
}
</script>
